import { cn } from '@sandtech-hub-monorepo/ui-kit';
import { formatDate } from '@sandtech-hub-monorepo/ui-kit-site';

import { BadgeActionsOverlay } from './BadgeActionsOverlay';
import { RevocationTooltip } from './RevocationTooltip';

interface Props {
  programName: string;
  imageUrl?: string | null;
  revoked: boolean;
  date?: string | null;
  shareUrl?: string | null;
  revocationReason?: string | null;
}

/** The certificate doubles as the program badge (see CertificateDefinition). */
export const ProgramBadgeCard = ({
  programName,
  imageUrl,
  revoked,
  date,
  shareUrl,
  revocationReason,
}: Props) => {
  const card = (
    <div className="group relative flex w-full flex-col items-center gap-1.5 overflow-hidden rounded-lg bg-heading p-3 text-center text-primary-foreground">
      {imageUrl && (
        <img
          src={imageUrl}
          alt={`${programName} badge`}
          className="h-14 w-auto"
        />
      )}
      <span
        className={cn(
          'rounded-[3px] px-1.5 py-0.5 text-[10px] font-medium',
          revoked
            ? 'bg-destructive/15 text-destructive'
            : 'bg-program-badge/15 text-program-badge'
        )}
      >
        {revoked ? 'Revoked' : 'Program Badge'}
      </span>
      <span className="text-sm">{programName}</span>
      {date && (
        <span className="text-[11px] text-primary-foreground/70">
          {revoked ? 'Revoked' : 'Earned'} on {formatDate(date)}
        </span>
      )}
      {!revoked && (
        <BadgeActionsOverlay
          imageUrl={imageUrl}
          fileName={`${programName} badge.png`}
          share={
            shareUrl
              ? {
                  title: programName,
                  typeLabel: 'Program',
                  imageUrl,
                  earnedAt: date,
                  shareUrl,
                }
              : undefined
          }
        />
      )}
    </div>
  );

  return revoked ? (
    <RevocationTooltip reason={revocationReason}>{card}</RevocationTooltip>
  ) : (
    card
  );
};
